import { Storage } from 'lamp'

const storage = new Storage('confor')

export default storage
